<template>
  <main>
    <div class="container">
      <al-modal
        :heading="$t('profileSettings.modalHeader')"
        :close-label="$t('button.cancel')"
        :cta-label="$t('profileSettings.deleteProfileBtn')"
        data-test="delete-profile-modal"
        name="confirm-delete-modal"
        @cta="handleProfileDelete">
        <div class="row">
          <div class="col-full">
            <p>{{ $t('profileSettings.modalContent') }}</p>
          </div>
        </div>
      </al-modal>
      <div class="row">
        <div class="col-full heading-xl">
          <h1 class="margin-bottom-sm">
            {{ $t('profileSettings.heading') }}
          </h1>
          <p class="heading-md margin-bottom-xs">
            {{ $t('common.userId') }}:
            <span data-test="email-string" class="p">{{ email }}</span>
          </p>
          <p class="heading-md margin-bottom-none">
            {{ $t('common.mobileNumber') }}:
            <span data-test="mobile-number-string" class="p">{{ mobileNumber }}</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-full">
          <hr class="margin-bottom-md margin-top-none" aria-hidden="true" />
        </div>
      </div>
      <div class="row">
        <div class="col-full">
          <h2 class="heading-md weight-bold">
            {{ $t('profileSettings.subheading') }}
          </h2>
        </div>
      </div>
      <div class="row">
        <div class="col-full">
          <div class="margin-left-none">
            <div class="col-full">
              <p class="color-secondary">
                {{ $t('profileSettings.line1') }}
              </p>
              <p class="color-secondary">
                {{ $t('profileSettings.line2') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-vertical-align-bottom">
        <div class="col-full align-center">
          <button
            v-toggle:al-modal="'confirm-delete-modal'"
            class="uppercase fill"
            data-test="delete-button"
            :aria-label="$t('profileSettings.deleteProfileBtn')">
            {{ $t('profileSettings.deleteProfileBtn') }}
          </button>
        </div>
        <div class="col-full align-center">
          <back-button v-analytics:click="$EVENTS.GO_BACK_BUTTON" :location="backButtonRoute">
            {{ $t('button.goBack') }}
          </back-button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlModal } from '@mc-alberta/alcapone'
import { mapActions, mapGetters } from 'vuex'
import BackButton from '@/components/BackButton'
import { LOADERS, ROUTES } from '@/constants'

export default {
  name: ROUTES.PROFILE_SETTINGS,
  components: { AlModal, BackButton },
  data() {
    return {
      backButtonRoute: { name: ROUTES.SETTINGS }
    }
  },
  computed: {
    ...mapGetters(['serviceErrorResponse', 'formattedUserEmail', 'formattedUserMobileNumber']),
    email() {
      return this.formattedUserEmail
    },
    mobileNumber() {
      return this.formattedUserMobileNumber(this)
    }
  },
  beforeDestroy() {
    this.clearServiceLayerError()
  },
  methods: {
    ...mapActions([
      'setMessagePageContent',
      'startLoader',
      'stopLoader',
      'stopLoaderWithSuccess',
      'deleteProfile',
      'clearServiceLayerError'
    ]),
    async handleProfileDelete() {
      this.clearServiceLayerError()
      this.startLoader(LOADERS.DELETE_PROFILE)

      await this.deleteProfile()
      if (this.serviceErrorResponse()) return this.handleError()

      this.$router.push({
        name: ROUTES.CONFIRM,
        params: { logout: true }
      })

      this.stopLoaderWithSuccess(LOADERS.DELETE_PROFILE)
    },

    handleError() {
      this.setMessagePageContent({
        buttonTarget: ROUTES.PROFILE_SETTINGS
      })
      this.$router.push({
        name: ROUTES.ERROR
      })
      this.stopLoader(LOADERS.DELETE_PROFILE)
    }
  }
}
</script>
